import type { ItsOneViewSabilSectionKey, ItsOneViewSectionKey } from "@/types/its-one-view";

export const SABIL_SECTION_KEYS: ItsOneViewSabilSectionKey[] = [
  "sabilChula",
  "sabilEstablishment",
  "sabilProfessional",
  "sabilMuttavatteen",
  "sabilMuttavatteenYearly",
  "sabilOther",
];

export const SECTION_ORDER: ItsOneViewSectionKey[] = [
  "fmbTakhmeen",
  "fmbZabihat",
  ...SABIL_SECTION_KEYS,
  "yearlyNiyaaz",
  "yearlyLedger",
  "projects",
  "events",
  "voluntary",
  "receipts",
  "hallBookings",
];

export const SECTION_LABELS: Record<ItsOneViewSectionKey, string> = {
  fmbTakhmeen: "FMB Takhmeen",
  fmbZabihat: "FMB Zabihat",
  sabilChula: "Sabil Chula",
  sabilEstablishment: "Sabil Establishment",
  sabilProfessional: "Sabil Professional",
  sabilMuttavatteen: "Sabil Muttavatteen",
  sabilMuttavatteenYearly: "Sabil Muttavatteen Yearly",
  sabilOther: "Sabil",
  yearlyNiyaaz: "Yearly Niyaaz",
  yearlyLedger: "Yearly Ledger",
  projects: "Projects",
  events: "Events",
  voluntary: "FMB Voluntary",
  receipts: "Receipts",
  hallBookings: "Hall Bookings",
};

const SABIL_SECTION_KEY_SET = new Set<string>(SABIL_SECTION_KEYS);

export function isSabilSectionKey(key: ItsOneViewSectionKey): key is ItsOneViewSabilSectionKey {
  return SABIL_SECTION_KEY_SET.has(key);
}

export function countForSection(
  key: ItsOneViewSectionKey,
  sections: import("@/types/its-one-view").ItsOneViewResponse["sections"] | undefined
): number {
  if (!sections) return 0;
  const block = sections[key];
  if (!block || !("items" in block)) return 0;
  return block.items.length;
}
